import api from './axiosConfig';
export const listAssessments    = (params) => api.get('/api/v1/assessments',                    { params });
export const createAssessment   = (data)   => api.post('/api/v1/assessments',                   data);
export const getAssessment      = (id)     => api.get(`/api/v1/assessments/${id}`);
export const updateAssessment   = (id, d)  => api.put(`/api/v1/assessments/${id}`,              d);
export const publishAssessment  = (id)     => api.post(`/api/v1/assessments/${id}/publish`);
export const closeAssessment    = (id)     => api.post(`/api/v1/assessments/${id}/close`);
export const duplicateAssessment= (id)     => api.post(`/api/v1/assessments/${id}/duplicate`);
export const archiveAssessment  = (id)     => api.delete(`/api/v1/assessments/${id}`);

export const getQuestions       = (id)     => api.get(`/api/v1/assessments/${id}/questions`);
export const addQuestions       = (id, d)  => api.post(`/api/v1/assessments/${id}/questions`,   d);
export const reorderQuestions   = (id, d)  => api.put(`/api/v1/assessments/${id}/questions/reorder`, d);
export const removeQuestion     = (id, qid)=> api.delete(`/api/v1/assessments/${id}/questions/${qid}`);

export const getLinks           = (id)     => api.get(`/api/v1/assessments/${id}/links`);
export const createLink         = (id, d)  => api.post(`/api/v1/assessments/${id}/links`,       d);
export const updateLink         = (lid, d) => api.put(`/api/v1/links/${lid}`,                   d);
export const disableLink        = (lid)    => api.delete(`/api/v1/links/${lid}`);
